export default __webpack_public_path__ + "static/media/title_page.edc32e96.jpg";